import {
  BUTTON_HEIGHT,
  FONT_SIZE,
  SCALE_BY_DISPLAY_SIZE,
  TEXT_SCALE_PROPS,
} from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import styled from "styled-components";

export const Styles = styled.div<TEXT_SCALE_PROPS>`
  background: #fff;
  border: 1px solid #ccc;

  // transition: transform 0.1s ease;
  &.dragging {
    z-index: 5001 !important;
    transition: transform 0s;
  }
  &.hidden {
    display: none;
  }
  .row_item {
    display: flex;
    position: relative;
    width: 100%;
    align-items: center;
    justify-content: center;
    height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL] + 13}px`} !important;
    border-bottom: 1px solid #ccc;
    padding: 0 10px;
    gap: 10px;
    font-weight: 700;
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
    &.label {
      background: rgba(51, 120, 189, 1);
      color: #fff;
      position: relative;
      .reside_bar-container {
        width: 4px;
        height: 15px;
        position: absolute;
        right: 0px;
        cursor: e-resize;
        .reside_bar {
          transform: translate(2px, 0);
          width: 2px;
          height: 15px;
          background: #ccc;
        }
      }
    }
    &:nth-child(even) {
      background: #efefef;
    }
    button {
      height: ${({ text_scale }) =>
        `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`};
      padding: 2px 5px;
      background: #174a83;
      color: #fff;
    }
    .wrap-action {
      cursor: pointer;
      &.disable {
        opacity: 0.5;
      }
    }
    .add-btn-container {
      position: absolute;
      top: 0;
      right: -0.5px;
      transform: translate(50%);
    }
    .btn-small-v {
      height: ${({ text_scale }) =>
        `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL] + 9}px`} !important;
      padding: 0px;
    }
    .ant-select-single: not(.ant-select-customize-input) .ant-select-selector {
      height: ${({ text_scale }) =>
        `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
      display: flex;
      align-items: center;
    }
    .ant-select-item-option-content,
    .ant-select-selection-item {
      font-size: ${({ text_scale }) =>
        FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
    }
    input[type="checkbox"] {
      width: unset !important;
      transform: ${({ text_scale }) =>
        `scale(${
          SCALE_BY_DISPLAY_SIZE[text_scale || DISPLAY_SIZES.SMALL]
        })`} !important;
      height: ${({ text_scale }) =>
        `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
    }
  }
  .ant-checkbox-inner {
    transform: ${({ text_scale }) =>
      `scale(${
        SCALE_BY_DISPLAY_SIZE[text_scale || DISPLAY_SIZES.SMALL]
      })`} !important;
    width: ${({ text_scale }) => {
      switch (text_scale) {
        case DISPLAY_SIZES.LARGE:
          return `${BUTTON_HEIGHT[DISPLAY_SIZES.LARGE] - 15}px`;
        case DISPLAY_SIZES.MEDIUM:
          return `${BUTTON_HEIGHT[DISPLAY_SIZES.MEDIUM] - 10}px`;
        default:
          return `${BUTTON_HEIGHT[DISPLAY_SIZES.SMALL] - 5}px`;
      }
    }} !important;

    height: ${({ text_scale }) => {
      switch (text_scale) {
        case DISPLAY_SIZES.LARGE:
          return `${BUTTON_HEIGHT[DISPLAY_SIZES.LARGE] - 15}px`;
        case DISPLAY_SIZES.MEDIUM:
          return `${BUTTON_HEIGHT[DISPLAY_SIZES.MEDIUM] - 10}px`;
        default:
          return `${BUTTON_HEIGHT[DISPLAY_SIZES.SMALL] - 5}px`;
      }
    }} !important;
  }
  .ant-input {
    height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
  }
`;
